import axios from 'axios' //引用axios
import QS from 'qs';
import {getCookie} from './package-cookies' //引用刚才我们创建的util.js文件，并使用getCookie方法
import router from "../src/router/index"
import Vue from 'vue'
import defaultSettings from '@/config/defaultSettings'
import ProcessHelper from '../src/utils/helper/ProcessHelper'
import { getItemFormLocalstorage } from '../utils/package-localstorage'


// axios 配置
axios.defaults.timeout = 60000;
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = process.env.VUE_APP_LocalRootUrl; //这是调用测试数据接口
} else {
    axios.defaults.baseURL = process.env.VUE_APP_PublishRootUrl; //线上
}


axios.defaults.headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Credentials': true,
    'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, PATCH, DELETE',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
}
// http request 拦截器，通过这个，我们就可以把Cookie传到后台
axios.interceptors.request.use(
    config => {
        //const chooseLanguage = getCookie('language')
        const chooseLanguage = getItemFormLocalstorage("language");
        if (chooseLanguage) {
            config.headers['accept-language'] = chooseLanguage
        }
        else {
            config.headers['accept-language'] = 'zh-Hans'
        }

        const token = localStorage.auth;
        //获取Cookie
        config.data = JSON.stringify(config.data);
        if (token) {
            config.headers.Authorization = "Bearer " + token //后台接收的参数，后面我们将说明后台如何接收
        }
        if (config.url.indexOf('seelabinteface.chinacloudsites.cn') != -1) {
            config.headers.Authorization = sessionStorage.getItem("Authorization")
        }else{
            config.headers.Authorization = "Bearer " + token
        }
        // console.log(config)
        return config;
    }, err => {
        return Promise.reject(err);
    }
);


// http response 拦截器
// 响应拦截器
// 响应拦截器
axios.interceptors.response.use(
    response => {
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        //  
        if (response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    error => {
        //  
        if (error.response) {
            switch (error.response.status) {

                //204
                case 204:
                    Vue.prototype.$message({
                        message: error.response.data.error.message,
                        type: "warning"
                    });
                    break;
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 400:
                    Vue.prototype.$message({
                        message: error.response.data.error.message,
                        type: "success"
                    });
                    break;
                case 401:

                    Vue.prototype.$message({
                        message: error.response.data.error.message,
                        type: "warning"
                    });

                    if (error.response.data.error.message.indexOf('Current user did not login to the application') != -1) {
                        localStorage.clear();
                        router.push({
                            path: '/login',
                        });
                    }
                    break;

                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    Vue.prototype.$message({
                        message: "没有权限",
                        type: "success"
                    });
                    break;
                // 404请求不存在
                case 404:
                    Vue.prototype.$message({
                        message: "不存在",
                        type: "warning"
                    });
                    break;
                case 405:
                    Vue.prototype.$message({
                        message: "不允许操作",
                        type: "warning"
                    });
                    break;
                case 409:
                    Vue.prototype.$message({
                        message: error.response.data.error.message,
                        type: "warning"
                    });
                    break;
                case 500:
                    Vue.prototype.$message({

                        message: error.response.data.error.message,
                        type: "error"
                    });
                    break;
                case 4009:

                    Vue.prototype.$message({

                        message: error.response.data.error.message,
                        type: "warning"
                    });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    // Toast({
                    //     message: error.response.data.message,
                    //     duration: 1500,
                    //     forbidClick: true
                    // });
                    Vue.prototype.$message({

                        message: error.response.data.error.message,
                        type: "warning"
                    });
                    break;

            }
            return Promise.reject(error.response);
        }
    });

export default axios;

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err.data)
        })
    });
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
 export function getExcel(url, params = {}) {
    return new Promise((resolve, reject) => {
        axios.get(url, 
        {
            params: params
        },
        {
            responseType: 'blob',
            headers: {
              'Content-Type': 'application/json'
            }
        }
        ).then(res => {
            resolve({ data: res.data});
        }).catch(err => {
            reject(err.data)
        })
    });
}

/**
 * fetch 请求方法
 * @param url
 * @param params
 * @returns {Promise}
 */
export function fetch(url, params = {}) {

    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * post 请求方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, params = {},timeoutParams={}) {
    return new Promise((resolve, reject) => {
        axios.post(url, params,timeoutParams)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}

/**
 * patch 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err);
            })
    })
}

/**
 * put 方法封装
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.put(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err.data);
            })
    })
}


export function axiosDelete(url, data = {}) {
    return new Promise((resolve, reject) => {
        axios.delete(url, {
            params: data
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err.data);
            })
    })
}
